<template>
  <div class="case">
    <div class="banner">
      <img :src="currentLg.banner" alt="" />
    </div>
    <div class="main">
      <div class="main-contents">
        <div class="list-btn">
          <div
            class="btn"
            :class="{ 'btn-checked': params.type == i.id }"
            v-for="(i, index) in typeList"
            :key="index"
            @click="changetype(i.id)"
          >
            <span>{{ i[`name_${locale}`] }}</span>
            <img
              v-show="params.type == i.id"
              src="./../assets/img/line.png"
              alt=""
            />
          </div>
        </div>
        <ul class="case-contnet">
          <li v-for="(item, index) in list" :key="item.id">
            <div class="case-img">
              <img :src="item.imgUrl" />
            </div>
            <div class="case-contain">
              <p class="case-name">
                <span>{{ locale == "CN" ? item.title : item.titleEn }}</span>
              </p>
              <p class="case-cn">
                <span v-show="locale == 'CN'" v-html="item.desc"></span>
                <span v-show="locale == 'EN'" v-html="item.descEn"></span>
              </p>
              <div
                v-show="locale == 'CN'"
                class="more-icon icon-cn"
                @click="more(item.id, item.type)"
              ></div>
              <div
                v-show="locale == 'EN'"
                class="more-icon icon-en"
                @click="more(item.id, item.type)"
              ></div>
            </div>
          </li>
        </ul>
        <div class="page">
          <el-pagination
            @current-change="getList"
            :current-page="params.pageNo"
            :page-size="params.size"
            layout="prev, pager, next"
            :total="totals"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import language from "./../language/case/index";
export default {
  data() {
    return {
      list: [],
      params: {
        pageNo: 1,
        pageSize: 8,
        type: 1,
      },
      totals: 0,
      typeList: [
        {
          name_CN: "商业",
          name_EN: "Commercial",
          id: 1,
        },
        {
          name_CN: "工厂",
          name_EN: "Factory",
          id: 2,
        },
        {
          name_CN: "数据中心",
          name_EN: "Data Center",
          id: 3,
        },
      ],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(type) {
      this.params.pageNo = type ? type : 1;
      this.$http
        .get("/api/portal/project/queryPage", {
          params: this.params,
        })
        .then((res) => {
          console.log(res);
          this.list = res.data && res.data.items ? res.data.items : [];
          this.totals =
            res.data && res.data.page && res.data.page.rowCount
              ? res.data.page.rowCount
              : 0;
        });
    },
    more(id, type) {
      let url =
        window.location.protocol +
        "//" +
        window.location.host +
        "/index_pc/caseview?id=" +
        id +
        "&&type=" +
        type;
      window.open(url);
    },
    changetype(type) {
      this.params.type = type;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.case {
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .main {
    .main-contents {
      .case-header {
        width: 100%;
        height: 88px;
        position: relative;
        margin: 0px auto;
        border-bottom: 1px dotted #cccccc;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        .case-header-left {
          margin-top: 29px;
          > li {
            display: inline-block;
            line-height: 50px;
            color: #4e4e4e;
            font-size: 12px;
          }
        }
      }
      .case-contnet {
        box-sizing: border-box;
        margin: 12px;
        display: flex;
        flex-wrap: wrap;
        margin: 0 15vw;
        li {
          padding: 24px 0;
          border-bottom: 1px dotted #cccccc;
          overflow: hidden;
          width: 30%;
          margin-right: 2vw;
          .case-img {
            width: 20vw;
            img {
              width: 100%;
              height: 100%;
              border-radius: 10px;
            }
          }

          .case-contain {
            flex: 1;
            overflow: hidden;
            box-sizing: border-box;
            .case-name {
              height: 50px;
              line-height: 50px;
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              span:first-child {
                color: #4e4e4e;
                font-size: 16px;
              }
              span:last-child {
                font-size: 16px;
                color: #4e4e4e;
              }
            }
            .case-cn {
              width: 20vw;
              height: 50px;
              font-size: 14px;
              color: #4e4e4e;
              line-height: 28px;
              overflow: hidden;
            }
            .more-icon {
              display: flex;
              justify-content: flex-end;
              width: 110px;
              height: 44px;
              z-index: 2;
              margin-top: 24px;
              cursor: pointer;
              background-repeat: no-repeat;
            }
            .icon-cn {
              background-image: url("./../assets/images/case/more-unSelect-cn.png");
            }
            .icon-en {
              background-image: url("./../assets/images/case/more-unSelect-en.png");
            }
          }
        }
        li:hover {
          .icon-cn {
            background-image: url("./../assets/images/case/more-select-cn.png");
          }
          .icon-en {
            background-image: url("./../assets/images/case/more-select-en.png");
          }
        }
      }
      .page {
        text-align: right;
        box-sizing: border-box;
        padding: 30px 0;
        .el-pagination {
          display: inline-block;
        }
      }
    }
  }
}

.list-btn {
  display: flex;
  border-bottom: 1px solid #d9d9d9;
  padding-left: 15vw;
}

.btn {
  cursor: pointer;
  position: relative;
  padding: 21px 0;
  margin-right: 76px;
  font-size: 16px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
  img {
    width: 39px;
    height: 4px;
    position: absolute;
    bottom: 0;
  }
}
.btn-checked {
  // border-bottom: 4px solid ;
  // border-image: linear-gradient(90deg, #1289D9 , #5CE282 ) 1;
  color: #1289d9;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/case.vue